<template>
  <el-dialog
    title="管理"
    :visible.sync="dialogVisible"
    width="60%"
    height="70vh"
    :before-close="closeManagementDialog"
    :modal-append-to-body="false"
    class="management-dialog">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="班级相关" name="class">
        <div class="class-management">
          
          <el-form label-position="right" label-width="120px" :model="classManagementForm">
            <el-form-item label="班级识别码：" class="no-margin-left">
              <div style="display: flex; align-items: center; margin-left: 15px;">
                <span class="class-code-text" style="user-select: text; cursor: text; font-weight: bold;">{{ classManagementForm.classCode }}</span>
                <el-button size="small" type="primary" @click="copyClassCode" icon="el-icon-document-copy" style="margin-left: 24px;">复制</el-button>
              </div>
            </el-form-item>
            <el-form-item label="班级级别：" class="no-margin-left">
              <el-select v-model="classManagementForm.grade" placeholder="请选择班级级别" @change="updateClassGrade" class="short-select">
                <el-option
                  v-for="grade in gradeOptions"
                  :key="grade.value"
                  :label="grade.label"
                  :value="grade.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="班级班别：" class="no-margin-left">
              <el-select v-model="classManagementForm.classNumber" placeholder="请选择班级班别" @change="updateClassNumber" class="short-select">
                <el-option
                  v-for="classNumber in classNumberOptions"
                  :key="classNumber.value"
                  :label="classNumber.label"
                  :value="classNumber.value">
                </el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item label="学生名单：">
              <div class="student-list" style="margin-top: 0;">
                <div style="margin-bottom: 10px; display: flex;">
                  <el-button @click="removeSelectedStudents" type="danger" size="small">删除选中</el-button>
                  <el-button @click="addStudents" type="primary" size="small" style="margin-left: 10px;" class="add-student-btn">添加学生</el-button>
                </div>
                <!-- 包裹表格的容器，用于处理圆角和滚动条问题 -->
                <div class="table-wrapper">
                  <el-table :data="classManagementForm.students" style="width: 100%" border @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column prop="studentNumber" label="学号" width="120"></el-table-column>
                    <el-table-column prop="name" label="姓名"></el-table-column>
                    <el-table-column label="操作" width="120" align="left" header-align="left">
                      <template slot-scope="scope">
                        <el-button @click="editStudent(scope.row)" type="text" class="edit-student-btn">编辑</el-button>
                        <el-button @click="deleteStudent(scope.row)" type="text" class="delete-student-btn">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
      
      <el-tab-pane label="作业相关" name="homework">
        <div class="homework-management">
          <el-form label-position="right" label-width="120px" :model="homeworkManagementForm">
            <el-form-item :label="'作业类型[' + currentSubjectName + ']：'" style="white-space: nowrap;">
              <div class="homework-types-container">
                <el-tree
                  class="homework-types-tree"
                  :data="homeworkTypesTreeData"
                  :props="treeProps"
                  :expand-on-click-node="false"
                  node-key="id"
                  highlight-current
                  :default-expanded-keys="[1, 2, 3]"
                  :disabled="false"
                  ref="homeworkTypesTree">
                  <span class="custom-tree-node" slot-scope="{ node, data }" :class="{'disabled-node': isSubjectDisabled(node)}" style="display: flex; align-items: center; justify-content: space-between; font-size: 16px; width: 100%; cursor: pointer;" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                    <span class="node-label" style="flex: 1; min-width: 0;" :class="{'disabled-text': isSubjectDisabled(node)}">{{ node.label }}</span>
                    <span v-if="data.type === 'subject'" class="node-actions" style="margin-left: 10px; display: flex; align-items: center;" :class="{'disabled-actions': isSubjectDisabled(node)}">
                      <el-button
                        type="text"
                        size="mini"
                        :disabled="isSubjectDisabled(node) || isHomeworkTypeLimitReached(data)"
                        @click="addHomeworkTypeToSubject(data)"
                        style="font-size: 16px;"
                        class="homework-type-btn">
                        添加作业类型
                      </el-button>
                    </span>
                    <span v-else class="node-actions" style="margin-left: 10px; display: flex; align-items: center;" :class="{'disabled-actions': isSubjectDisabled(node)}">
                      <el-button
                        type="text"
                        size="mini"
                        :disabled="isSubjectDisabled(node)"
                        @click="renameHomeworkType(node, data)"
                        style="font-size: 16px;"
                        class="homework-type-btn">
                        重命名
                      </el-button>
                      <el-button
                        type="text"
                        size="mini"
                        :disabled="isSubjectDisabled(node)"
                        @click="moveHomeworkType(node, data, 'up')"
                        style="font-size: 16px;"
                        class="homework-type-btn">
                        上移
                      </el-button>
                      <el-button
                        type="text"
                        size="mini"
                        :disabled="isSubjectDisabled(node)"
                        @click="moveHomeworkType(node, data, 'down')"
                        style="font-size: 16px;"
                        class="homework-type-btn">
                        下移
                      </el-button>
                      <el-button
                        type="text"
                        size="mini"
                        :disabled="isSubjectDisabled(node)"
                        @click="removeHomeworkTypeFromTree(node, data)"
                        style="font-size: 16px;"
                        class="homework-type-btn">
                        删除
                      </el-button>
                    </span>
                  </span>
                </el-tree>
              </div>
            </el-form-item>
            
            <el-form-item :label="'作业记录[' + currentSubjectName + ']：'">
              <div class="homework-records" style="margin-top: 0;">
                <div style="margin-bottom: 10px; display: flex;">
                  <el-button @click="removeSelectedHomeworkRecords" type="danger" size="small">删除选中</el-button>
                </div>
                <!-- 包裹表格的容器，用于处理圆角和滚动条问题 -->
                <div class="table-wrapper">
                  <el-table :data="homeworkRecords" style="width: 100%" border :row-class-name="tableRowClassName" ref="homeworkRecordsTable" @selection-change="handleHomeworkSelectionChange">
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column prop="date" label="日期" width="100" sortable="custom"></el-table-column>
                    <el-table-column prop="typeName" label="作业类型" width="115" sortable="custom"></el-table-column>
                    <el-table-column prop="content" label="作业内容" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <span style="word-break: break-word;">{{ scope.row.content }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="finishedCount" label="已订正" width="65" align="center">
                      <template slot-scope="scope">
                        <span style="color: green; font-weight: bold;">{{ scope.row.finishedCount }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="unfinishedCount" label="未订正" width="65" align="center">
                      <template slot-scope="scope">
                        <span style="color: red; font-weight: bold;">{{ scope.row.unfinishedCount }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="120" align="center">
                      <template slot-scope="scope">
                        <el-button @click="editHomeworkContent(scope.row)" type="text" style="color: #409EFF;">修改内容</el-button>
                        <el-button @click="deleteHomeworkRecord(scope.row)" type="text" style="color: #409EFF; margin-left: 10px;">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
      
      <el-tab-pane label="个人相关" name="personal">
        <div class="personal-management">
          <div class="personal-info">
            <div class="personal-info-header">
              <div class="personal-info-title">
                <h3>我的信息</h3>
              </div>
              <div class="personal-info-actions">
                <el-button 
                  v-if="!isEditingPersonalInfo" 
                  type="text" 
                  icon="el-icon-edit" 
                  @click="startEditPersonalInfo">
                  修改
                </el-button>
                <div v-else class="edit-actions">
                  <el-button @click="cancelEditPersonalInfo" size="mini">取消</el-button>
                  <el-button type="primary" @click="savePersonalInfo" size="mini">保存</el-button>
                </div>
              </div>
              <el-button 
                type="primary" 
                size="small"
                @click="showChangePasswordDialog" style="margin-right: 10px;">
                修改密码
              </el-button>
              <el-button 
                type="danger" 
                size="small"
                @click="handleLogout">
                退出登录
              </el-button>
            </div>
            <div class="personal-info-content">
              <el-form label-position="left" label-width="100px" class="personal-info-form">
                <el-form-item label="我的昵称：">
                  <el-input 
                    v-model="myNickname" 
                    :placeholder="isEditingPersonalInfo ? '请输入昵称' : ''"
                    :disabled="!isEditingPersonalInfo"></el-input>
                </el-form-item>
                <el-form-item label="我的邮箱：">
                  <el-input 
                    v-model="myEmail" 
                    :placeholder="isEditingPersonalInfo ? '请输入邮箱' : ''"
                    :disabled="!isEditingPersonalInfo"></el-input>
                </el-form-item>
                <el-form-item label="我的手机：">
                  <el-input 
                    v-model="myPhone" 
                    :placeholder="isEditingPersonalInfo ? '请输入手机号' : ''"
                    :disabled="!isEditingPersonalInfo"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
          
          <div class="my-classes">
            <div class="my-classes-header">
              <h3>我的班级</h3>
              <div class="my-classes-actions">
                <el-button 
                  type="primary" 
                  size="small"
                  @click="goToNewClass"
                  :disabled="myClasses.length >= 5"
                  :class="{ 'disabled-class-btn': myClasses.length >= 5 }"
                  :title="myClasses.length >= 5 ? '您已加入5个班级，无法再新建班级' : ''">
                  新建班级
                </el-button>
                <el-button 
                  type="primary" 
                  size="small"
                  @click="goToJoinClass"
                  :disabled="myClasses.length >= 5"
                  :class="{ 'disabled-class-btn': myClasses.length >= 5 }"
                  :title="myClasses.length >= 5 ? '您已加入5个班级，无法再加入班级' : ''">
                  加入班级
                </el-button>
                <el-button 
                  type="danger" 
                  size="small"
                  @click="confirmUnbindClass">
                  解绑班级
                </el-button>
              </div>
            </div>
            <div class="class-buttons">
              <el-button 
                v-for="classInfo in myClasses" 
                :key="classInfo.id"
                plain
                :class="{ 'current-class': isCurrentClass(classInfo) }"
                @click="switchToClass(classInfo)"
                class="class-info-button">
                <div class="class-main-info">
                  <div class="class-name">{{ classInfo.name }} - {{ classInfo.subjectName }}</div>
                </div>
                <div class="student-count">
                  人数：{{ classInfo.studentCount }}人
                </div>
                <div class="other-subjects">
                  <!-- 显示其他两个科目的绑定情况，如果没有绑定则显示'未绑定' -->
                  <div v-for="subjectName in ['语文', '数学', '英语'].filter(s => s !== classInfo.subjectName)" :key="subjectName" class="subject-line">
                    {{ subjectName }}：{{ classInfo.otherSubjects[subjectName] || '未绑定' }}
                  </div>
                </div>
              </el-button>
            </div>
          </div>
        </div>
      </el-tab-pane>
      
      <el-tab-pane label="关于" name="about">
        <div class="about-management">
          <div class="about-content">
            <div class="project-intro">
              <h3>项目简介</h3>
              <p class="intro-text">
                本项目是一个基于Spring Boot和Vue.js开发的作业批改管理系统，旨在帮助教师高效管理班级作业、学生信息以及作业记录。系统采用前后端分离架构，支持PC端和移动端访问，为教师提供便捷的作业管理工具。
              </p>
              <p class="intro-text">
                系统支持多班级管理、多科目作业类型自定义、作业记录统计、学生作业追踪等功能，有效提升教师工作效率，让作业管理更加智能化、便捷化。
              </p>
            </div>
            
            <div class="feature-list">
              <h3>功能特性</h3>
              <ul class="features">
                <li class="feature-item">
                  <i class="el-icon-check"></i>
                  <span>多班级管理：支持同时管理多个班级，每个班级可独立设置作业类型和科目</span>
                </li>
                <li class="feature-item">
                  <i class="el-icon-check"></i>
                  <span>多科目支持：支持语文、数学、英语三大科目，每个科目可自定义作业类型</span>
                </li>
                <li class="feature-item">
                  <i class="el-icon-check"></i>
                  <span>作业记录管理：记录每日作业内容，支持快速添加、修改和删除作业记录</span>
                </li>
                <li class="feature-item">
                  <i class="el-icon-check"></i>
                  <span>学生作业追踪：实时跟踪学生作业完成情况，已订正和未订正一目了然</span>
                </li>
                <li class="feature-item">
                  <i class="el-icon-check"></i>
                  <span>快速录入：支持批量添加学生、手动快录、批量录入等多种录入方式</span>
                </li>
                <li class="feature-item">
                  <i class="el-icon-check"></i>
                  <span>主题切换：支持语文、数学、英语三种主题，界面美观，操作便捷</span>
                </li>
                <li class="feature-item">
                  <i class="el-icon-check"></i>
                  <span>移动端适配：完美支持手机端访问，随时随地管理作业</span>
                </li>
                <li class="feature-item">
                  <i class="el-icon-check"></i>
                  <span>数据统计：自动统计作业完成率，帮助教师了解班级整体情况</span>
                </li>
              </ul>
            </div>
            
            <div class="tech-stack">
              <h3>技术栈</h3>
              <div class="tech-items">
                <div class="tech-item">
                  <div class="tech-icon backend">后端</div>
                  <div class="tech-details">
                    <p class="tech-name">Spring Boot</p>
                    <p class="tech-desc">基于Spring Boot框架，提供RESTful API接口</p>
                  </div>
                </div>
                <div class="tech-item">
                  <div class="tech-icon frontend">前端</div>
                  <div class="tech-details">
                    <p class="tech-name">Vue.js + Element UI</p>
                    <p class="tech-desc">使用Vue.js框架和Element UI组件库</p>
                  </div>
                </div>
                <div class="tech-item">
                  <div class="tech-icon database">数据库</div>
                  <div class="tech-details">
                    <p class="tech-name">MySQL</p>
                    <p class="tech-desc">使用MySQL数据库存储数据</p>
                  </div>
                </div>
                <div class="tech-item">
                  <div class="tech-icon auth">认证</div>
                  <div class="tech-details">
                    <p class="tech-name">JWT</p>
                    <p class="tech-desc">使用JWT进行用户身份认证</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="author-info">
              <h3>作者信息</h3>
              <div class="author-details">
                <div class="author-basic">
                  <p class="author-name"><strong>作者：</strong>林老师</p>
                  <p class="author-version"><strong>版本：</strong>v1.0.0</p>
                  <p class="author-update"><strong>更新时间：</strong>2026年2月</p>
                </div>
                <div class="wechat-qrcode">
                  <div class="qrcode-container">
                    <p class="wechat-label"><strong>微信二维码</strong></p>
                    <p class="wechat-tip">扫码添加作者微信，获取更多帮助</p>
                    <img src="/images/wechat-qrcode.png" alt="微信二维码" class="qrcode-image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    
    <!-- 添加学生弹窗 -->
    <el-dialog
      title="添加学生"
      :visible.sync="showAddStudentsDialog"
      width="40%"
      custom-class="management-add-students-dialog"
      append-to-body
      :close-on-click-modal="false"
      :before-close="() => { showAddStudentsDialog = false; addStudentsText = ''; }">
      <div style="margin-bottom: 10px;">
        <strong>请按以下格式输入学生姓名：</strong><br>
        <span style="color: #999; font-size: 14px;">（每行一个学生姓名，仅限汉字，最多4个字）</span>
      </div>
      <div class="add-students-container" style="position: relative;">
        <el-input
          type="textarea"
          :rows="10"
          :placeholder="addStudentsPlaceholder"
          v-model="addStudentsText"
          class="aligned-textarea">
        </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddStudentsDialog = false; addStudentsText = '';">取 消</el-button>
        <el-button type="primary" @click="importAddedStudents">确 定</el-button>
      </div>
    </el-dialog>
    
    <!-- 学生编辑弹窗 -->
    <el-dialog
      title="编辑学生信息"
      :visible.sync="studentEditDialogVisible"
      width="30%"
      append-to-body
      :close-on-click-modal="false"
      :before-close="closeStudentEditDialog"
      class="student-edit-dialog">
      <el-form :model="currentStudent" label-width="80px">
        <el-form-item label="学号">
          <el-input v-model="currentStudent.studentNumber" placeholder="请输入学号"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="currentStudent.name" placeholder="请输入学生姓名"></el-input>
        </el-form-item>
        <el-form-item label="拼音首字母" style="white-space: nowrap !important;">
          <el-input v-model="currentStudent.pinyinInitials" placeholder="请输入拼音首字母"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeStudentEditDialog">取 消</el-button>
        <el-button type="primary" @click="saveStudentInfo">确 定</el-button>
      </span>
    </el-dialog>
    
    <!-- 作业内容编辑弹窗 -->
    <HomeworkContentDialog
      :visible.sync="homeworkContentDialogVisible"
      :content="tempHomeworkContent"
      theme="management"
      @save="saveHomeworkContent"
      @close="closeHomeworkContentDialog"
      append-to-body />
      
    <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="changePasswordDialogVisible"
      width="25%"
      custom-class="management-dialog"
      append-to-body
      :close-on-click-modal="false">
      <el-form :model="changePasswordForm" :rules="changePasswordRules" ref="changePasswordForm" label-width="140px" class="change-password-form">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input type="password" v-model="changePasswordForm.oldPassword" placeholder="请输入原密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="changePasswordForm.newPassword" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="再次输入新密码" prop="confirmPassword" style="white-space: nowrap !important;">
          <el-input type="password" v-model="changePasswordForm.confirmPassword" placeholder="请再次输入新密码" show-password></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changePasswordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="changePassword">确定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import EventBus from '../../utils/EventBus'
import HomeworkContentDialog from './dialogs/HomeworkContentDialog.vue'
import Utils from '@/utils/Utils'

export default {
  name: 'ManagementDialog',
  components: {
    HomeworkContentDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    classId: {
      type: Number,
      default: null
    },
    subjectIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      activeTab: 'class',
      // 班级管理表单相关
      classManagementForm: {
        classCode: '',
        grade: '',
        classNumber: null,
        students: []
      },
      // 作业管理表单相关
      homeworkManagementForm: {},
      // 作业记录数据
      homeworkRecords: [],
      // 作业记录表格多选状态
      homeworkMultipleSelection: [],
      // 临时作业内容
      tempHomeworkContent: '',
      // 作业内容编辑对话框可见性
      homeworkContentDialogVisible: false,
      // 当前编辑的作业记录
      editingHomeworkRecord: null,
      gradeOptions: [
        {value: 1, label: '一年级'},
        {value: 2, label: '二年级'},
        {value: 3, label: '三年级'},
        {value: 4, label: '四年级'},
        {value: 5, label: '五年级'},
        {value: 6, label: '六年级'},
        {value: 7, label: '初一'},
        {value: 8, label: '初二'},
        {value: 9, label: '初三'},
        {value: 10, label: '高一'},
        {value: 11, label: '高二'},
        {value: 12, label: '高三'}
      ],
      classNumberOptions: [
        {value: 1, label: '1班'},
        {value: 2, label: '2班'},
        {value: 3, label: '3班'},
        {value: 4, label: '4班'},
        {value: 5, label: '5班'},
        {value: 6, label: '6班'},
        {value: 7, label: '7班'},
        {value: 8, label: '8班'},
        {value: 9, label: '9班'},
        {value: 10, label: '10班'},
        {value: 11, label: '11班'},
        {value: 12, label: '12班'},
        {value: 13, label: '13班'},
        {value: 14, label: '14班'},
        {value: 15, label: '15班'},
        {value: 16, label: '16班'},
        {value: 17, label: '17班'},
        {value: 18, label: '18班'},
        {value: 19, label: '19班'},
        {value: 20, label: '20班'}
      ],
      // 作业类型管理相关
      homeworkTypesTreeData: [
        {
          id: 1,
          label: '语文',
          type: 'subject',
          children: []
        },
        {
          id: 2,
          label: '数学',
          type: 'subject',
          children: []
        },
        {
          id: 3,
          label: '英语',
          type: 'subject',
          children: []
        }
      ],
      treeProps: {
        children: 'children',
        label: 'label'
      },
      chineseHomeworkTypeInputVisible: false,
      chineseHomeworkTypeInputValue: '',
      mathHomeworkTypeInputVisible: false,
      mathHomeworkTypeInputValue: '',
      englishHomeworkTypeInputVisible: false,
      englishHomeworkTypeInputValue: '',
      // 学生管理相关
      multipleSelection: [],
      studentEditDialogVisible: false,
      currentStudent: {},
      // 个人资料编辑相关
      isEditingPersonalInfo: false,
      // 保存原始数据用于取消编辑
      originalNickname: '',
      originalEmail: '',
      originalPhone: '',
      // 个人资料相关
      myNickname: '',
      myEmail: '',
      myPhone: '',
      myClasses: [],
      // 当前教师ID
      currentTeacherId: null,
      // 当前教师在该班级任教的科目ID列表
      teacherSubjectIds: [],
      currentSubjectId: null,
      // 作业记录排序相关
      sortField: 'date', // 默认按日期排序
      sortOrder: 'desc', // 默认降序
      // 记录上一次的排序状态，用于处理null情况
      lastSort: {
        field: 'date',
        order: 'descending'
      },
      // 添加学生弹窗相关
      showAddStudentsDialog: false,
      addStudentsText: '',
      // 添加学生提示文案（包含换行）
      addStudentsPlaceholder: '请输入学生姓名，每行一个学生' + String.fromCharCode(10) + '格式示例：' + String.fromCharCode(10) + '张三' + String.fromCharCode(10) + '李四' + String.fromCharCode(10) + '王五',
      // 修改密码相关
      changePasswordDialogVisible: false,
      changePasswordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      changePasswordRules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '新密码长度不能少于6个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.changePasswordForm.newPassword) {
                callback(new Error('两次输入的密码不一致'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    currentSubjectName() {
      // 根据当前教师在该班级任教的科目来显示
      if (this.teacherSubjectIds && this.teacherSubjectIds.length > 0) {
        const subjectNames = ['语文', '数学', '英语'];
        // 如果教师任教多个科目，显示第一个科目
        const primarySubjectId = this.teacherSubjectIds[0];
        return subjectNames[primarySubjectId - 1] || '未知';
      }
      // 如果还没有获取到任教科目信息，就显示未知
      return '未知';
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal;
    },
    dialogVisible(newVal) {
      if (newVal && this.activeTab === 'class') {
        // 当对话框显示且标签页为班级相关时，加载班级管理数据
        this.loadClassManagementData();
      } else if (newVal && this.activeTab === 'personal') {
        // 当对话框显示且标签页为个人相关时，加载个人相关信息
        this.loadPersonalInfo();
        this.loadMyClasses();
      } else if (newVal && this.activeTab === 'homework') {
        // 当对话框显示且标签页为作业相关时，加载作业相关数据
        this.loadHomeworkManagementData();
      }
    },
    // 监听标签页切换
    activeTab(newVal, oldVal) {
      if (newVal === 'class') {
        // 当切换到或保持在班级相关标签页时，加载班级管理数据
        this.loadClassManagementData();
      } else if (newVal === 'personal') {
        // 当切换到个人相关标签页时，加载个人相关信息
        this.loadPersonalInfo();
        this.loadMyClasses();
      } else if (newVal === 'homework') {
        // 当切换到作业相关标签页时，加载作业相关数据
        this.loadHomeworkManagementData();
      }
    }
  },
  methods: {
    closeManagementDialog() {
      this.dialogVisible = false;
      this.$emit('update:visible', false);
      this.$emit('management-closed');
    },
    copyClassCode() {
      const classCode = this.classManagementForm.classCode;
      const gradeLevel = this.classManagementForm.grade;
      const classNumber = this.classManagementForm.classNumber;

      if (!classCode) {
        this.$message.warning('班级识别码为空，无法复制');
        return;
      }

      const className = Utils.formatClassName(gradeLevel, classNumber);
      const formattedText = `班级：${className}的班级识别码是：${classCode}，请勿将该班级识别码外传给陌生人。`;

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(formattedText)
            .then(() => {
              this.$message({
                type: 'success',
                message: '班级信息复制成功!'
              });
            })
            .catch(err => {
              console.error('复制失败:', err);
              this.fallbackCopyText(formattedText);
            });
      } else {
        // 降级方案：使用 execCommand
        this.fallbackCopyText(formattedText);
      }
    },
    getChineseGrade(gradeLevel) {
      const grades = {
        1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六',
        7: '初一', 8: '初二', 9: '初三',
        10: '高一', 11: '高二', 12: '高三'
      };
      return grades[gradeLevel] || gradeLevel;
    },
    fallbackCopyText(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;

      // 避免滚动到底部
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message({
            type: 'success',
            message: '班级识别码复制成功!'
          });
        } else {
          this.$message.error('复制失败，请手动复制');
        }
      } catch (err) {
        console.error('复制失败:', err);
        this.$message.error('复制失败，请手动复制');
      }

      document.body.removeChild(textArea);
    },
    updateClassGrade() {
      if (!this.classId) {
        this.$message.error('未找到班级ID');
        return;
      }

      this.$http.put(`/classes/update?classId=${this.classId}`, {
        gradeLevel: this.classManagementForm.grade,
        classNumber: this.classManagementForm.classNumber, // 同时发送当前的classNumber以保持数据完整性
        classCode: this.classManagementForm.classCode // 同时发送当前的classCode以保持数据完整性
      }).then(response => {
        if (response.data.success) {
          this.$message.success('班级级别更新成功');
          // 通知父组件班级信息已更新
          this.notifyClassInfoUpdate();
        } else {
          this.$message.error(response.data.message || '班级级别更新失败');
          // 如果更新失败，回滚到原来的值
          this.loadClassManagementData();
        }
      }).catch(error => {
        console.error('更新班级级别失败:', error);
        this.$message.error('更新班级级别失败: ' + (error.response?.data?.message || error.message || '未知错误'));
        // 更新失败，回滚到原来的值
      });
    },
    updateClassNumber() {
      if (!this.classId) {
        this.$message.error('未找到班级ID');
        return;
      }

      this.$http.put(`/classes/update?classId=${this.classId}`, {
        classNumber: this.classManagementForm.classNumber,
        gradeLevel: this.classManagementForm.grade, // 同时发送当前的gradeLevel以保持数据完整性
        classCode: this.classManagementForm.classCode // 同时发送当前的classCode以保持数据完整性
      }).then(response => {
        if (response.data.success) {
          this.$message.success('班级班别更新成功');
          // 更新成功后刷新"我的班级"按钮显示
          this.loadMyClasses();
          // 同时刷新班级标题显示
          this.loadClassBasicData();
        } else {
          this.$message.error(response.data.message || '班级班别更新失败');
          // 如果更新失败，回滚到原来的值
          this.loadClassManagementData();
        }
      }).catch(error => {
        console.error('更新班级班别失败:', error);
        this.$message.error('更新班级班别失败: ' + (error.response?.data?.message || error.message || '未知错误'));
        // 更新失败，回滚到原来的值
        this.loadClassBasicData();
      });
    },
    loadClassManagementData() {
      if (!this.classId) {
        console.warn('No classId available for loading management data');
        return;
      }

      // 设置当前教师任教的科目ID
      this.currentSubjectId = this.subjectIndex + 1;

      // 加载班级信息
      this.$http.get(`/classes/${this.classId}`).then(classResponse => {
        if (classResponse.data.success && classResponse.data.class) {
          const classInfo = classResponse.data.class;

          this.classManagementForm.classCode = classInfo.classCode;
          this.classManagementForm.grade = classInfo.gradeLevel;

          const parsedClassNumber = parseInt(classInfo.classNumber);
          this.classManagementForm.classNumber = parsedClassNumber;

          // 加载学生信息
          this.loadStudentsForManagement();
        }
      }).catch(error => {
        console.error('加载班级管理信息失败:', error);
        this.$message.error('加载班级管理信息失败: ' + (error.response?.data?.message || error.message || '未知错误'));
      });
    },
    
    // 加载作业管理数据
    loadHomeworkManagementData() {
      if (!this.classId) {
        console.warn('No classId available for loading homework management data');
        return;
      }

      // 设置当前教师任教的科目ID
      this.currentSubjectId = this.subjectIndex + 1;
      
      // 获取当前教师在该班级任教的科目
      this.getCurrentTeacherSubjects().then(() => {
        // 加载作业类型
        this.loadHomeworkTypesForManagement();
        
        // 加载作业记录
        this.loadHomeworkRecords();
      });
    },
    loadHomeworkTypesForManagement() {
      // 加载语文作业类型
      this.$http.get(`/homeworkTypes/class?classId=${this.classId}&subjectId=1`).then(chineseResponse => {
        this.classManagementForm.chineseHomeworkTypes = chineseResponse.data;

        // 加载数学作业类型
        return this.$http.get(`/homeworkTypes/class?classId=${this.classId}&subjectId=2`);
      }).then(mathResponse => {
        this.classManagementForm.mathHomeworkTypes = mathResponse.data;

        // 加载英语作业类型
        return this.$http.get(`/homeworkTypes/class?classId=${this.classId}&subjectId=3`);
      }).then(englishResponse => {
        this.classManagementForm.englishHomeworkTypes = englishResponse.data;

        // 初始化作业类型树数据
        this.initHomeworkTypesTree();
      }).catch(error => {
        console.error('加载作业类型失败:', error);
      });
    },
    initHomeworkTypesTree() {
      // 重置树形数据
      this.homeworkTypesTreeData = [
        {
          id: 1,
          label: '语文',
          type: 'subject',
          children: []
        },
        {
          id: 2,
          label: '数学',
          type: 'subject',
          children: []
        },
        {
          id: 3,
          label: '英语',
          type: 'subject',
          children: []
        }
      ];
      
      // 为每个科目填充子节点
      if (this.classManagementForm.chineseHomeworkTypes) {
        this.homeworkTypesTreeData[0].children = this.classManagementForm.chineseHomeworkTypes.map(type => ({
          id: type.id,
          label: type.name,
          type: 'homework'
        }));
      }
      
      if (this.classManagementForm.mathHomeworkTypes) {
        this.homeworkTypesTreeData[1].children = this.classManagementForm.mathHomeworkTypes.map(type => ({
          id: type.id,
          label: type.name,
          type: 'homework'
        }));
      }
      
      if (this.classManagementForm.englishHomeworkTypes) {
        this.homeworkTypesTreeData[2].children = this.classManagementForm.englishHomeworkTypes.map(type => ({
          id: type.id,
          label: type.name,
          type: 'homework'
        }));
      }
    },
    loadStudentsForManagement() {
      this.$http.get(`/students/class?classId=${this.classId}`).then(response => {
        // 对学生数据按学号进行数值排序
        this.classManagementForm.students = response.data.sort((a, b) => {
          // 将学号转换为数字进行比较，以确保数值排序而不是字符串排序
          const numA = parseInt(a.studentNumber, 10) || 0;
          const numB = parseInt(b.studentNumber, 10) || 0;
          return numA - numB;
        });
      }).catch(error => {
        console.error('加载学生信息失败:', error);
      });
    },
    addHomeworkTypeToSubject(parentData) {
      this.$prompt('请输入作业类型名称', '添加作业类型', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: '',
        inputPlaceholder: '请输入作业类型名称',
        inputValidator: (value) => {
          if (!value || value.trim() === '') return '请输入作业类型名称';
          if (value.length > 30) return '作业类型名称不能超过30个字符';
          // 检查是否存在同名的作业类型
          if (parentData.children && parentData.children.some(child => child.label.trim() === value.trim())) {
            return '该作业类型名称已存在，请输入不同的名称';
          }
          return true;
        },
        inputErrorMessage: '作业类型名称格式不正确',
        closeOnClickModal: false
      }).then(({value}) => {
        // 获取科目ID（根据父节点的ID）
        const subjectId = parentData.id;
        
        // 调用API创建作业类型
        this.$http.post('/homeworkTypes/addToSubject', {
          name: value.trim(),
          subjectId: subjectId,
          classId: this.classId
        }).then(response => {
          // 检查响应中的success字段
          if (response.data && response.data.success) {
            // 获取后端返回的作业类型数据
            const homeworkTypeData = response.data.homeworkType;
            const newHomeworkType = {
              id: homeworkTypeData.id,
              label: homeworkTypeData.name,
              type: 'homework'
            };

            // 如果父节点没有children数组，则创建一个
            if (!parentData.children) {
              parentData.children = [];
            }

            // 添加新作业类型
            parentData.children.push(newHomeworkType);

            this.$message.success(response.data.message || '添加成功');
            
            // 更新本地管理表单数据
            this.updateLocalHomeworkTypes(subjectId, homeworkTypeData, 'add');
            
            // 通过事件总线通知其他组件作业类型已更新
            EventBus.$emit('homework-types-updated', {
              classId: this.classId,
              subjectId: subjectId,
              operation: 'add',
              data: homeworkTypeData
            });
          } else {
            this.$message.error(response.data.message || '添加失败');
          }
        }).catch(error => {
          console.error('添加作业类型失败:', error);
          this.$message.error('添加失败: ' + (error.response?.data?.message || error.message || '未知错误'));
        });
      }).catch(() => {
        // 用户取消操作
      });
    },
    renameHomeworkType(node, data) {
      // 找到当前节点的父节点
      const parentNode = this.findParentNode(this.homeworkTypesTreeData, data);

      this.$prompt('请输入新的作业类型名称', '重命名', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: data.label,
        inputValidator: (value) => {
          if (!value) return '请输入作业类型名称';
          if (value.length > 30) return '作业类型名称不能超过30个字符';
          // 检查是否存在同名的作业类型
          if (parentNode && parentNode.children &&
              parentNode.children.some(child => child.id !== data.id && child.label.trim() === value.trim())) {
            return '该作业类型名称已存在，请输入不同的名称';
          }
          return true;
        },
        inputErrorMessage: '作业类型名称格式不正确'
      }).then(({value}) => {
        // 调用后端API更新作业类型名称
        this.$http.put(`/homeworkTypes/${data.id}`, {
          name: value.trim()
        }).then(response => {
          // 检查响应是否包含id字段，这表示作业类型更新成功
          if (response.data && response.data.id) {
            // 更新树形数据中的标签
            data.label = value;
            this.$message.success('重命名成功');
            
            // 更新本地管理表单数据
            this.updateLocalHomeworkTypes(parentNode.id, {id: response.data.id, name: value}, 'update');
            
            // 通过事件总线通知其他组件作业类型已更新
            EventBus.$emit('homework-types-updated', {
              classId: this.classId,
              subjectId: parentNode.id,
              operation: 'update',
              data: {id: response.data.id, name: value}
            });
          } else {
            this.$message.error(response.data.message || '重命名失败');
          }
        }).catch(error => {
          console.error('重命名作业类型失败:', error);
          this.$message.error('重命名失败: ' + (error.response?.data?.message || error.message || '未知错误'));
        });
      }).catch(() => {
        // 取消操作
      });
    },
    moveHomeworkType(node, data, direction) {
      // 找到当前节点的父节点
      const parentNode = this.findParentNode(this.homeworkTypesTreeData, data);
      if (!parentNode || !parentNode.children) {
        return;
      }

      const siblings = parentNode.children;
      const index = siblings.findIndex(item => item.id === data.id);

      if (index === -1) {
        return;
      }

      if (direction === 'up' && index > 0) {
        // 上移：与前一个元素交换位置
        [siblings[index - 1], siblings[index]] = [siblings[index], siblings[index - 1]];
      } else if (direction === 'down' && index < siblings.length - 1) {
        // 下移：与后一个元素交换位置
        [siblings[index], siblings[index + 1]] = [siblings[index + 1], siblings[index]];
      } else {
        return;
      }

      // 触发重新渲染
      this.homeworkTypesTreeData = [...this.homeworkTypesTreeData];

      // 调用后端接口更新排序
      this.updateHomeworkTypeOrder(parentNode, siblings, direction, data);
    },
    removeHomeworkTypeFromTree(node, data) {
      // 检查节点是否被禁用，如果是，则不允许删除
      if (this.isSubjectDisabled(node)) {
        this.$message.warning('您无权操作其他科目的作业类型');
        return;
      }

      // 确认删除操作
      this.$confirm(`确定要删除作业类型 "${data.label}" 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 如果是新增的节点（id为负数或临时ID），只需要从本地删除
        if (data.id < 0 || typeof data.id === 'string') {
          // 找到父节点并从其中删除该子节点
          const parentNode = node.parent;
          const childNodes = parentNode.childNodes;
          const index = childNodes.findIndex(child => child.data.id === data.id);

          if (index > -1) {
            // 从树形数据中删除
            const parentData = parentNode.data;
            if (parentData.children) {
              parentData.children.splice(index, 1);
            }

            this.$message.success('删除成功');
          }
        } else {
          // 如果是已有数据，调用后端API删除
          this.$http.delete(`/homeworkTypes/${data.id}`).then(response => {
            // 检查响应中的success字段
            if (response.data && response.data.success) {
              // 找到父节点并从其中删除该子节点
              const parentNode = node.parent;
              const childNodes = parentNode.childNodes;
              const index = childNodes.findIndex(child => child.data.id === data.id);

              if (index > -1) {
                // 从树形数据中删除
                const parentData = parentNode.data;
                if (parentData.children) {
                  parentData.children.splice(index, 1);
                }

                this.$message.success(response.data.message || '删除成功');
                
                // 更新本地管理表单数据
                this.updateLocalHomeworkTypes(parentNode.data.id, data, 'remove');
                
                // 通过事件总线通知其他组件作业类型已更新
                EventBus.$emit('homework-types-updated', {
                  classId: this.classId,
                  subjectId: parentNode.data.id,
                  operation: 'remove',
                  data: data
                });
              }
            } else {
              // 后端返回失败，显示具体的错误信息
              this.$message.error(response.data.message || '删除失败');
            }
          }).catch(error => {
            // 如果是网络错误或其他异常，显示通用错误信息
            this.$message.error('删除失败: ' + (error.response?.data?.message || error.message || '未知错误'));
          });
        }
      }).catch(() => {
        // 用户取消操作
      });
    },
    updateHomeworkTypeOrder(parentNode, siblings, direction, movedItem) {
      // 根据父节点ID确定科目ID
      const subjectId = parentNode.id; // 假设节点ID就是科目ID

      // 构建更新数据，包含排序信息
      const updateData = {
        subjectId: subjectId,
        homeworkTypes: siblings.map((type, index) => ({
          id: type.id,
          name: type.label || type.name,
          sortOrder: index + 1 // 排序从1开始
        }))
      };

      // 调用后端API更新排序
      this.$http.put(`/homeworkTypes/updateOrder`, updateData).then(response => {
        // 检查响应是否包含success字段或直接成功
        if (response.data.success || (response.data && !response.data.message)) {
          this.$message.success('作业类型顺序已更新');
          
          // 只有在后端更新成功后才通知其他组件
          EventBus.$emit('homework-types-updated', {
            classId: this.classId,
            subjectId: subjectId,
            operation: 'move',
            data: {
              direction: direction,
              movedItem: movedItem,
              siblings: siblings
            }
          });
        } else {
          this.$message.error('更新作业类型顺序失败: ' + response.data.message);
        }
      }).catch(error => {
        this.$message.error('更新作业类型顺序失败: ' + (error.response?.data?.message || error.message));
      });
    },
    isSubjectDisabled(node) {
      // 如果还没有获取到当前教师任教的科目信息，暂时不禁用任何节点
      if (!this.teacherSubjectIds || this.teacherSubjectIds.length === 0) {
        return false;
      }

      // 如果是科目节点（type为subject），判断是否为当前教师任教的科目
      if (node.data.type === 'subject') {
        return !this.teacherSubjectIds.includes(node.data.id);
      }

      // 如果是作业类型节点，判断其父节点（科目）是否为当前教师任教的科目
      const parentNode = this.findParentNode(this.homeworkTypesTreeData, node.data);
      if (parentNode && parentNode.type === 'subject') {
        return !this.teacherSubjectIds.includes(parentNode.id);
      }

      return false;
    },
    isHomeworkTypeLimitReached(subjectData) {
      if (!subjectData.children) {
        return false;
      }
      return subjectData.children.length >= 20;
    },
    findParentNode(treeData, targetNode) {
      for (let i = 0; i < treeData.length; i++) {
        const item = treeData[i];
        if (item.children) {
          if (item.children.some(child => child.id === targetNode.id)) {
            return item;
          }
          // 递归查找
          const found = this.findParentNode(item.children, targetNode);
          if (found) return found;
        }
      }
      return null;
    },
    
    // 更新本地作业类型数据
    updateLocalHomeworkTypes(subjectId, homeworkType, operation) {
      let homeworkTypesArray;
      
      // 根据科目ID选择对应的数组
      switch(subjectId) {
        case 1:
          homeworkTypesArray = this.classManagementForm.chineseHomeworkTypes;
          break;
        case 2:
          homeworkTypesArray = this.classManagementForm.mathHomeworkTypes;
          break;
        case 3:
          homeworkTypesArray = this.classManagementForm.englishHomeworkTypes;
          break;
        default:
          // 如果subjectId不是1、2、3之一，则不执行任何操作
          return;
      }
      
      if (operation === 'add') {
        // 添加作业类型
        homeworkTypesArray.push(homeworkType);
      } else if (operation === 'remove') {
        // 删除作业类型
        const index = homeworkTypesArray.findIndex(type => type.id === homeworkType.id);
        if (index !== -1) {
          homeworkTypesArray.splice(index, 1);
        }
      } else if (operation === 'update') {
        // 更新作业类型
        const index = homeworkTypesArray.findIndex(type => type.id === homeworkType.id);
        if (index !== -1) {
          // 更新作业类型的名称
          homeworkTypesArray[index].name = homeworkType.name;
        }
      }
    },
    handleMouseEnter(event) {
      const target = event.currentTarget;
      if (target.classList.contains('disabled-node')) {
        target.style.cursor = 'not-allowed';
      }
    },
    handleMouseLeave(event) {
      const target = event.currentTarget;
      target.style.cursor = 'pointer';
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    
    // 处理作业记录表格选择变化
    handleHomeworkSelectionChange(val) {
      this.homeworkMultipleSelection = val;
    },
    
    // 删除选中的作业记录
    removeSelectedHomeworkRecords() {
      if (this.homeworkMultipleSelection.length === 0) {
        this.$message.warning('请至少选择一条作业记录');
        return;
      }

      this.$confirm(`确定要删除选中的${this.homeworkMultipleSelection.length}条作业记录吗？此操作将删除这些作业的所有订正记录。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 构建要删除的作业记录参数
        const deleteParams = this.homeworkMultipleSelection.map(record => ({
          date: record.date,
          typeId: record.homeworkTypeId,
          classId: this.classId
        }));
        
        // 调用批量删除接口
        this.$http.post('/homeworkAssignments/batch-delete', deleteParams)
          .then(response => {
            if (response.data.success) {
              this.$message.success(`成功删除${response.data.deletedCount}条作业记录!`);
              
              // 从本地列表中移除
              this.homeworkMultipleSelection.forEach(selectedRecord => {
                const index = this.homeworkRecords.findIndex(r => 
                  r.date === selectedRecord.date && r.homeworkTypeId === selectedRecord.homeworkTypeId
                );
                if (index > -1) {
                  this.homeworkRecords.splice(index, 1);
                }
              });
              
              // 清空选择
              this.homeworkMultipleSelection = [];
              
              console.log('ManagementDialog发出批量作业删除事件:', {
                records: deleteParams,
                classId: this.classId
              });
              // 通过事件总线通知StudentGrid更新学生按钮订正状态
              EventBus.$emit('homework-records-batch-deleted', {
                records: deleteParams,
                classId: this.classId
              });
            } else {
              this.$message.error(response.data.message || '删除失败');
            }
          })
          .catch(error => {
            console.error('批量删除作业记录失败:', error);
            this.$message.error('删除失败: ' + (error.response?.data?.message || error.message || '未知错误'));
          });
      }).catch(() => {
        // 用户取消操作
      });
    },
    addStudents() {
      // 显示批量录入弹窗
      this.showAddStudentsDialog = true;
      this.addStudentsText = '';
    },
    removeSelectedStudents() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请至少选择一名学生');
        return;
      }

      this.$confirm(`确定要删除选中的${this.multipleSelection.length}名学生吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 收集要删除的学生ID
        const studentIds = this.multipleSelection.map(student => student.id);
        
        // 调用批量删除接口，使用POST请求体传递数组
        this.$http.post('/students/delete', {
          ids: studentIds
        }).then(response => {
          if (response.data.success) {
            this.$message.success(response.data.message);
            // 重新加载学生列表
            this.loadStudentsForManagement();
            this.multipleSelection = [];
            
            // 通过事件总线通知StudentGrid更新数据
            EventBus.$emit('student-deleted', {
              studentIds: studentIds,
              classId: this.classId
            });
          } else {
            this.$message.error(response.data.message || '删除失败');
          }
        }).catch(error => {
          console.error('批量删除学生失败:', error);
          this.$message.error('删除失败: ' + (error.response?.data?.message || error.message || '未知错误'));
        });
      }).catch(() => {
        // 用户取消操作
      });
    },
    editStudent(student) {
      this.currentStudent = {...student};
      this.studentEditDialogVisible = true;
    },
    deleteStudent(student) {
      this.$confirm(`确定要删除学生 "${student.name}" 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用删除接口，使用POST请求体传递数组
        this.$http.post('/students/delete', {
          ids: [student.id]
        }).then(response => {
          if (response.data.success) {
            this.$message.success(response.data.message);
            // 重新加载学生列表
            this.loadStudentsForManagement();
            
            // 通过事件总线通知StudentGrid更新数据
            EventBus.$emit('student-deleted', {
              studentIds: [student.id],
              classId: this.classId
            });
          } else {
            this.$message.error(response.data.message || '删除失败');
          }
        }).catch(error => {
          console.error('删除学生失败:', error);
          this.$message.error('删除失败: ' + (error.response?.data?.message || error.message || '未知错误'));
        });
      }).catch(() => {
        // 用户取消操作
      });
    },
    saveStudentInfo() {
      // 前端验证
      if (!this.currentStudent.name || !this.currentStudent.name.trim()) {
        this.$message.error('学生姓名不能为空');
        return;
      }
      
      if (!this.currentStudent.studentNumber || !this.currentStudent.studentNumber.trim()) {
        this.$message.error('学号不能为空');
        return;
      }
      
      if (!this.currentStudent.pinyinInitials || !this.currentStudent.pinyinInitials.trim()) {
        this.$message.error('拼音首字母不能为空');
        return;
      }
      
      // 验证拼音首字母格式（只能包含字母，不能有空格和特殊符号）
      const pinyinPattern = /^[a-zA-Z]+$/;
      if (!pinyinPattern.test(this.currentStudent.pinyinInitials.trim())) {
        this.$message.error('拼音首字母只能包含字母，不能包含空格或特殊符号');
        return;
      }
      
      // 检查学号是否在班级内重复
      const duplicateStudent = this.classManagementForm.students.find(s => 
        s.id !== this.currentStudent.id && 
        s.studentNumber === this.currentStudent.studentNumber.trim()
      );
      
      if (duplicateStudent) {
        this.$message.error(`学号 ${this.currentStudent.studentNumber.trim()} 已被学生 ${duplicateStudent.name} 使用`);
        return;
      }
      
      // 自动转换拼音首字母为小写
      this.currentStudent.pinyinInitials = this.currentStudent.pinyinInitials.toLowerCase().trim();
      
      this.$http.put('/students', this.currentStudent, {
        params: {
          id: this.currentStudent.id
        }
      }).then(response => {
        // 处理后端返回的新格式 {success: boolean, message: string, student: Student}
        if (response.data && response.data.success) {
          // 重新加载整个学生列表以确保数据一致性
          this.loadStudentsForManagement();
          
          this.$message.success(response.data.message || '保存成功');
          this.studentEditDialogVisible = false;
          
          // 通过事件总线通知其他组件学生信息已更新
          EventBus.$emit('student-info-updated', {
            student: response.data.student,
            classId: this.classId
          });
        } else {
          this.$message.error(response.data.message || '保存失败');
        }
      }).catch(error => {
        console.error('保存学生信息失败:', error);
        this.$message.error('保存失败: ' + (error.response?.data?.message || error.message || '未知错误'));
      });
    },
    closeStudentEditDialog() {
      this.studentEditDialogVisible = false;
    },
    importAddedStudents() {
      if (!this.addStudentsText.trim()) {
        this.$message.warning('请输入学生信息');
        return;
      }

      const lines = this.addStudentsText.split('\n').filter(line => line.trim() !== '');
      const invalidLines = [];
      const validStudents = [];

      // 验证学生姓名格式
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        if (line === '') continue;

        // 验证格式：不超过4个汉字，不含标点符号
        if (!/^[一-\u9fa5]{1,4}$/.test(line)) {
          invalidLines.push({line: i + 1, content: line});
        } else {
          validStudents.push({
            name: line,
            originalLine: i + 1
          });
        }
      }

      if (invalidLines.length > 0) {
        let errorMsg = '以下行格式不正确（格式：姓名，每行一个，不带学号与标点符号，不超过4个汉字）：\n';
        invalidLines.forEach(item => {
          errorMsg += `第${item.line}行: ${item.content}\n`;
        });
        this.$alert(errorMsg.replace(/\n/g, '<br/>'), '格式错误', {
          confirmButtonText: '确定',
          type: 'error',
          dangerouslyUseHTMLString: true
        });
        return;
      }

      // 获取当前班级的已有学生列表，用于重名检查和人数限制检查
      let existingStudents = [];
      if (this.classId) {
        this.$http.get(`/students/class?classId=${this.classId}`).then(response => {
          existingStudents = response.data || [];
          
          // 检查班级人数限制（最多70人）
          const currentStudentCount = existingStudents.length;
          const newStudentCount = validStudents.length;
          if (currentStudentCount + newStudentCount > 70) {
            this.$alert(
              `添加失败：班级人数不能超过70人<br/>
               当前已有：${currentStudentCount}人<br/>
               本次添加：${newStudentCount}人<br/>
               总计：${currentStudentCount + newStudentCount}人`, 
              '人数超限', {
              confirmButtonText: '确定',
              type: 'error',
              dangerouslyUseHTMLString: true
            }).catch(() => {
              // 用户点击关闭按钮或遮罩层时的处理
              console.log('用户关闭了人数超限弹窗');
            });
            return;
          }
          
          this.processValidStudents(validStudents, existingStudents);
        }).catch(error => {
          console.error('获取已有学生列表失败:', error);
          // 即使获取失败也不中断操作，只是无法检查与已有学生的重名
          this.processValidStudents(validStudents, existingStudents);
        });
      } else {
        this.processValidStudents(validStudents, existingStudents);
      }
    },
    processValidStudents(validStudents, existingStudents) {
      // 检查待添加学生之间的重名
      const nameCounts = {};
      const duplicateWithinInput = [];

      for (const student of validStudents) {
        if (nameCounts[student.name]) {
          nameCounts[student.name].push(student.originalLine);
        } else {
          nameCounts[student.name] = [student.originalLine];
        }
      }

      // 收集待添加学生之间的重名
      for (const [name, lines] of Object.entries(nameCounts)) {
        if (lines.length > 1) {
          duplicateWithinInput.push({
            name: name,
            lines: lines
          });
        }
      }

      // 检查与已有学生的重名
      const duplicateWithExisting = [];
      for (const student of validStudents) {
        const isDuplicate = existingStudents.some(existingStudent => existingStudent.name === student.name);
        if (isDuplicate) {
          duplicateWithExisting.push({
            name: student.name,
            line: student.originalLine
          });
        }
      }

      // 如果有重名情况，提示用户
      if (duplicateWithinInput.length > 0 || duplicateWithExisting.length > 0) {
        let errorMsg = '发现重名学生，请修改后再添加：\n';

        if (duplicateWithinInput.length > 0) {
          duplicateWithinInput.forEach(dup => {
            errorMsg += `姓名"${dup.name}"在第${dup.lines.join('、')}行重复\n`;
          });
        }

        if (duplicateWithExisting.length > 0) {
          duplicateWithExisting.forEach(dup => {
            errorMsg += `姓名"${dup.name}"与已有学生重名（第${dup.line}行）\n`;
          });
        }

        // 去除最后多余的换行符
        errorMsg = errorMsg.trimEnd();

        this.$alert(errorMsg.replace(/\n/g, '<br/>'), '重名检查', {
          confirmButtonText: '确定',
          type: 'error',
          dangerouslyUseHTMLString: true
        }).catch(() => {
          // 用户取消操作（点击叉号或遮罩层），什么都不做
        });
        return;
      }

      // 验证通过，使用批量接口添加学生
      const studentNames = validStudents.map(student => student.name);
      
      this.$http.post('/students/batch', {
        classId: this.classId,
        studentNames: studentNames
      }).then(response => {
        if (response.data.success) {
          this.$message.success(response.data.message);
          this.showAddStudentsDialog = false;
          this.addStudentsText = '';

          // 重新加载学生列表
          this.loadStudentsForManagement();
          this.$emit('refresh-students'); // 通知父组件刷新学生列表
          
          // 通过事件总线通知StudentGrid刷新数据
          EventBus.$emit('student-added', {
            classId: this.classId,
            count: studentNames.length
          });
        } else {
          throw new Error(response.data.message || '批量添加学生失败');
        }
      }).catch(error => {
        console.error('批量添加学生失败:', error);
        this.$message.error('添加失败: ' + (error.response?.data?.message || error.message || '未知错误'));
      });
    },
    updateLineCount() {
      // 由于我们使用了计算属性，所以这里只需触发更新即可
    },
    loadPersonalInfo() {
      if (!this.currentTeacherId) {
        console.warn('Current teacher ID not available');
        return;
      }

      this.$http.get(`/teachers/profile`).then(response => {
        if (response.data.success) {
          const profile = response.data.profile;
          this.myNickname = profile.nickname || '';
          this.myEmail = profile.email || '';
          this.myPhone = profile.phone || '';
        }
      }).catch(error => {
        console.error('加载个人信息失败:', error);
      });
    },
    loadMyClasses() {
      if (!this.currentTeacherId) {
        console.warn('Current teacher ID not available');
        return;
      }

      this.$http.get(`/teachers/myClasses`).then(response => {
        if (response.data.success) {
          // 并行获取所有班级的详细信息
          const classPromises = response.data.classes.map(cls => {
            // 获取学生人数
            return this.$http.get(`/students/class?classId=${cls.id}`).then(studentsResponse => {
              let studentCount = 0;
              if (studentsResponse.data && Array.isArray(studentsResponse.data)) {
                studentCount = studentsResponse.data.length;
              }

              // 获取其他科目教师绑定情况（排除当前用户任教的科目）
              let otherSubjects = {};
              return this.$http.get(`/teachers/${cls.id}/teachers-by-class`).then(classTeachersResponse => {
                if (classTeachersResponse.data.success && classTeachersResponse.data.teachers) {
                  for (const teacherInfo of classTeachersResponse.data.teachers) {
                    // 只添加非当前用户任教的科目
                    if (cls.subjectId !== teacherInfo.subjectId) {
                      const subjectName = this.getSubjectNameById(teacherInfo.subjectId);
                      otherSubjects[subjectName] = teacherInfo.teacherNickname;
                    }
                  }

                  // 确保未绑定的科目也显示'未绑定'
                  const allSubjects = ['语文', '数学', '英语'];
                  for (const subject of allSubjects) {
                    if (subject !== cls.subjectName && !(subject in otherSubjects)) {
                      otherSubjects[subject] = '未绑定';
                    }
                  }
                } else {
                  // 如果无法获取详细信息，使用默认值
                  // 注意：这里只设置非当前用户任教的科目
                  otherSubjects = {};
                  const allSubjects = ['语文', '数学', '英语'];
                  for (const subject of allSubjects) {
                    if (subject !== cls.subjectName) {
                      otherSubjects[subject] = '未绑定';
                    }
                  }
                }

                return {
                  id: cls.id,
                  name: cls.name,
                  subjectName: cls.subjectName,
                  subjectId: cls.subjectId, // 保存科目ID用于后续比较
                  studentCount: studentCount,
                  otherSubjects: otherSubjects
                };
              }).catch(teacherError => {
                console.error(`获取班级 ${cls.id} 教师绑定信息失败:`, teacherError);
                // 如果无法获取详细信息，使用默认值
                // 注意：这里只设置非当前用户任教的科目
                const otherSubjects = {};
                const allSubjects = ['语文', '数学', '英语'];
                for (const subject of allSubjects) {
                  if (subject !== cls.subjectName) {
                    otherSubjects[subject] = '未绑定';
                  }
                }

                return {
                  id: cls.id,
                  name: cls.name,
                  subjectName: cls.subjectName,
                  subjectId: cls.subjectId, // 保存科目ID用于后续比较
                  studentCount: studentCount,
                  otherSubjects: otherSubjects
                };
              });
            }).catch(studentError => {
              console.error(`获取班级 ${cls.id} 学生人数失败:`, studentError);
              // 如果获取学生人数失败，使用默认值
              return {
                id: cls.id,
                name: cls.name,
                subjectName: cls.subjectName,
                subjectId: cls.subjectId, // 保存科目ID用于后续比较
                studentCount: 0,
                otherSubjects: {}
              };
            });
          });

          Promise.all(classPromises).then(classes => {
            this.myClasses = classes;
          });
        }
      }).catch(error => {
        console.error('加载我的班级失败:', error);
      });
    },
    getSubjectNameById(subjectId) {
      const subjectNames = {1: '语文', 2: '数学', 3: '英语'};
      return subjectNames[subjectId] || '未知';
    },
    startEditPersonalInfo() {
      // 保存原始数据用于取消编辑
      this.originalNickname = this.myNickname;
      this.originalEmail = this.myEmail;
      this.originalPhone = this.myPhone;
      this.isEditingPersonalInfo = true;
    },
    cancelEditPersonalInfo() {
      // 恢复原始数据
      this.myNickname = this.originalNickname;
      this.myEmail = this.originalEmail;
      this.myPhone = this.originalPhone;
      this.isEditingPersonalInfo = false;
    },
    savePersonalInfo() {
      if (!this.currentTeacherId) {
        this.$message.error('当前教师ID未获取，无法保存资料');
        return;
      }

      this.$http.put('/teachers/profile', {
        id: this.currentTeacherId,
        nickname: this.myNickname,
        email: this.myEmail,
        phone: this.myPhone
      }).then(response => {
        if (response.data.success) {
          this.$message.success('个人资料保存成功');
          this.isEditingPersonalInfo = false;
        } else {
          this.$message.error(response.data.message || '保存失败');
        }
      }).catch(error => {
        console.error('保存个人资料失败:', error);
        this.$message.error('保存失败: ' + (error.response?.data?.message || error.message || '未知错误'));
      });
    },
    switchToClass(classInfo) {
      // 构建目标URL并刷新整个页面
      const targetUrl = `/class/${classInfo.id}?subjectId=${this.getSubjectIdByName(classInfo.subjectName)}`;
      window.location.href = targetUrl;
      this.dialogVisible = false;
    },
    getSubjectIdByName(subjectName) {
      const subjects = ['语文', '数学', '英语'];
      const subjectIndex = subjects.indexOf(subjectName);
      return subjectIndex + 1;
    },
    isCurrentClass(classInfo) {
      // 只需要判断班级ID是否匹配，不需要考虑科目
      // 因为用户可能切换到非自己任教的科目，但仍应该高亮当前所在的班级
      return classInfo.id == this.classId;
    },
    confirmUnbindClass() {
      // 获取当前班级信息
      const currentClass = this.myClasses.find(classInfo => classInfo.id == this.classId);
      const className = currentClass ? currentClass.name : '当前班级';
      
      this.$confirm(`解绑班级时，将同时删除您在该班级所教科目的作业类型、订正记录和作业内容数据。<br>确定要解绑当前班级 <span style="color: red; font-weight: bold;">${className}</span> 吗？`, '重要提示', {
        confirmButtonText: '确定解绑',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        // 检查当前班级是否只有该老师绑定
        this.$http.get(`/teacherClass/checkTeachersCount?classId=${this.classId}`).then(checkResponse => {
          if (checkResponse.data.success && checkResponse.data.count === 1) {
            // 只有一位老师，提示用户
            const currentClass = this.myClasses.find(classInfo => classInfo.id == this.classId);
            const className = currentClass ? currentClass.name : '当前班级';
            
            this.$confirm(`当前班级（<span style="color: red; font-weight: bold;">${className}</span>）只绑定了您一位老师，如果解绑，将同时删除该班级，请问是否解绑并删除班级？`, '重要提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              dangerouslyUseHTMLString: true
            }).then(() => {
              // 执行解绑和删除班级
              this.unbindClass(true);
            }).catch(() => {
              // 用户取消操作
            });
          } else {
            // 多位老师，直接解绑
            this.unbindClass(false);
          }
        }).catch(error => {
          console.error('检查教师数量失败:', error);
          this.$message.error('操作失败: ' + (error.response?.data?.message || error.message || '未知错误'));
        });
      }).catch(() => {
        // 用户取消操作
      });
    },
    unbindClass(deleteClass) {
      this.$http.delete(`/teachers/unbind?classId=${this.classId}&deleteClass=${deleteClass}`).then(response => {
        if (response.data.success) {
          this.$message.success('解绑成功');
          // 退出登录，跳转到登录页面
          localStorage.removeItem('token');
          this.$router.push('/login');
          this.dialogVisible = false;
        } else {
          this.$message.error(response.data.message || '解绑失败');
        }
      }).catch(error => {
        console.error('解绑班级失败:', error);
        this.$message.error('解绑失败: ' + (error.response?.data?.message || error.message || '未知错误'));
      });
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用后端接口使JWT失效
        this.$http.post('/auth/logout').catch(error => {
          console.error('登出失效处理失败:', error);
        }).finally(() => {
          // 清除本地存储的用户信息
          localStorage.removeItem('teacherInfo');
          localStorage.removeItem('token');
          localStorage.removeItem('deviceType');
          localStorage.removeItem('sessionId');

          // 跳转到登录页面
          this.$router.push('/login');

          // 提示用户退出成功
          this.$message({
            type: 'success',
            message: '已退出登录!'
          });

          // 关闭管理弹窗
          this.dialogVisible = false;
        });
      }).catch(() => {
        // 用户取消操作
      });
    },
    goToNewClass() {
      // 检测当前是否在移动端环境
      const deviceType = localStorage.getItem('deviceType') || 'pc';
      const isMobile = deviceType === 'mobile';
      
      // 根据当前环境决定跳转到PC端还是移动端
      const route = isMobile ? '/newclassmobile' : '/newclass';
      
      this.$router.push(route);
      this.dialogVisible = false;
    },
    goToJoinClass() {
      // 检测当前是否在移动端环境
      const deviceType = localStorage.getItem('deviceType') || 'pc';
      const isMobile = deviceType === 'mobile';
      
      // 根据当前环境决定跳转到PC端还是移动端
      const route = isMobile ? '/joinclassmobile' : '/joinclass';
      
      this.$router.push(route);
      this.dialogVisible = false;
    },
    // 显示修改密码对话框
    showChangePasswordDialog() {
      this.changePasswordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
      this.changePasswordDialogVisible = true;
    },
    // 修改密码
    changePassword() {
      this.$refs.changePasswordForm.validate((valid) => {
        if (valid) {
          this.$http.post('/teachers/changePassword', {
            oldPassword: this.changePasswordForm.oldPassword,
            newPassword: this.changePasswordForm.newPassword
          }).then(response => {
            if (response.data.success) {
              this.$message.success('密码修改成功，请重新登录');
              this.changePasswordDialogVisible = false;
              // 直接执行退出登录流程，不需要确认
              this.$http.post('/auth/logout').catch(error => {
                console.error('登出失效处理失败:', error);
              }).finally(() => {
                // 清除本地存储的用户信息
                localStorage.removeItem('teacherInfo');
                localStorage.removeItem('token');
                localStorage.removeItem('deviceType');
                localStorage.removeItem('sessionId');

                // 跳转到登录页面
                this.$router.push('/login');

                // 提示用户退出成功
                this.$message({
                  type: 'success',
                  message: '已退出登录!'
                });

                // 关闭管理弹窗
                this.dialogVisible = false;
              });
            } else {
              this.$message.error(response.data.message || '密码修改失败');
            }
          }).catch(error => {
            console.error('修改密码失败:', error);
            this.$message.error('修改失败: ' + (error.response?.data?.message || error.message || '未知错误'));
          });
        } else {
          return false;
        }
      });
    },
    loadClassBasicData() {
      if (!this.classId) {
        this.$message.error('未找到班级ID');
        return;
      }

      this.$http.get(`/classes/${this.classId}`).then(response => {
        if (response.data.success) {
          this.classManagementForm.grade = response.data.class.gradeLevel;
          this.classManagementForm.classNumber = response.data.class.classNumber;
          this.classManagementForm.classCode = response.data.class.classCode;
          // 通知父组件班级信息已更新
          this.notifyClassInfoUpdate();
        } else {
          this.$message.error(response.data.message || '加载班级数据失败');
        }
      }).catch(error => {
        console.error('加载班级数据失败:', error);
        this.$message.error('加载班级数据失败: ' + (error.response?.data?.message || error.message || '未知错误'));
      });
    },
    
    // 通知父组件班级信息已更新
    notifyClassInfoUpdate() {
      // 重新加载班级基本信息并通过事件总线发送更新事件
      this.$http.get(`/classes/${this.classId}`).then(response => {
        if (response.data.success && response.data.class) {
          // 通过事件总线发送班级信息更新事件
          EventBus.$emit('class-info-updated', response.data.class);
        }
      }).catch(error => {
        console.error('获取更新后的班级信息失败:', error);
      });
    },
    
    // 获取当前教师ID
    async getCurrentTeacherId() {
      try {
        // 通过获取教师档案的方式获取当前教师ID
        const response = await this.$http.get('/teachers/profile');
        if (response.data.success && response.data.profile) {
          this.currentTeacherId = response.data.profile.id;
        }
      } catch (error) {
        console.error('获取当前教师ID失败:', error);
      }
    },
    
    // 获取当前教师在指定班级任教的科目
    async getCurrentTeacherSubjects() {
      if (!this.classId) {
        console.warn('缺少必要的参数: classId');
        return Promise.resolve();
      }
      
      try {
        const response = await this.$http.get('/teacherClass/getTeacherSubjects', {
          params: {
            classId: this.classId
          }
        });
        
        if (response.data.success && response.data.subjectIds) {
          this.teacherSubjectIds = response.data.subjectIds;
          console.log('获取到教师任教科目:', this.teacherSubjectIds);
        } else {
          console.warn('获取教师任教科目失败:', response.data.message);
          this.teacherSubjectIds = [];
        }
      } catch (error) {
        this.teacherSubjectIds = [];
      }
    },
    
    // 处理日期排序
    handleDateSort(sortInfo) {
      // 如果排序为null，则使用与上次相反的排序
      if (sortInfo.order === null) {
        // 设置为与上次相反的排序
        sortInfo.order = this.lastSort.order === 'descending' ? 'ascending' : 'descending';
      }
      
      // 无论什么情况，都要确保只有一个列处于排序状态
      if (this.$refs.homeworkRecordsTable) {
        const columns = this.$refs.homeworkRecordsTable.columns;
        columns.forEach(col => {
          if (col.property !== 'date') {
            col.order = null;
          }
        });
        
        // 更新当前列的排序状态
        const currentColumn = columns.find(col => col.property === 'date');
        if (currentColumn) {
          currentColumn.order = sortInfo.order;
        }
      }
      
      // 保存当前排序状态
      this.lastSort = {
        field: 'date',
        order: sortInfo.order
      };
      
      // 根据排序信息进行排序
      if (sortInfo.order === 'ascending') {
        this.sortField = 'date';
        this.sortOrder = 'asc';
      } else {
        this.sortField = 'date';
        this.sortOrder = 'desc';
      }
      
      this.sortHomeworkRecords();
    },
    
    // 处理作业类型排序
    handleTypeSort(sortInfo) {
      // 如果排序为null，则使用与上次相反的排序
      if (sortInfo.order === null) {
        // 设置为与上次相反的排序
        sortInfo.order = this.lastSort.order === 'descending' ? 'ascending' : 'descending';
      }
      
      // 无论什么情况，都要确保只有一个列处于排序状态
      if (this.$refs.homeworkRecordsTable) {
        const columns = this.$refs.homeworkRecordsTable.columns;
        columns.forEach(col => {
          if (col.property !== 'typeName') {
            col.order = null;
          }
        });
        
        // 更新当前列的排序状态
        const currentColumn = columns.find(col => col.property === 'typeName');
        if (currentColumn) {
          currentColumn.order = sortInfo.order;
        }
      }
      
      // 保存当前排序状态
      this.lastSort = {
        field: 'typeName',
        order: sortInfo.order
      };
      
      // 根据排序信息进行排序
      if (sortInfo.order === 'ascending') {
        this.sortField = 'typeName';
        this.sortOrder = 'asc';
      } else {
        this.sortField = 'typeName';
        this.sortOrder = 'desc';
      }
      
      this.sortHomeworkRecords();
    },
    
    // 对作业记录进行排序
    sortHomeworkRecords() {
      this.homeworkRecords.sort((a, b) => {
        let primaryResult = 0;
        let secondaryResult = 0;
        
        if (this.sortField === 'date') {
          // 主排序：日期排序
          primaryResult = new Date(a.date) - new Date(b.date);
          // 次级排序：作业类型sortOrder升序（始终保持升序）
          secondaryResult = (a.homeworkTypeSortOrder || 0) - (b.homeworkTypeSortOrder || 0);
        } else if (this.sortField === 'typeName') {
          // 主排序：作业类型排序（按homeworkTypeSortOrder字段）
          primaryResult = (a.homeworkTypeSortOrder || 0) - (b.homeworkTypeSortOrder || 0);
          // 次级排序：日期升序（始终保持升序）
          secondaryResult = new Date(a.date) - new Date(b.date);
        }
        
        // 应用主排序方向
        if (this.sortOrder === 'desc') {
          primaryResult = -primaryResult;
        }
        
        // 如果主排序相等，则使用次级排序（次级排序始终保持升序）
        if (primaryResult === 0) {
          return secondaryResult;
        }
        
        return primaryResult;
      });
    },
    
    // 表格行样式类名
    tableRowClassName({row, rowIndex}) {
      if (this.homeworkRecords && this.homeworkRecords.length > 0) {
        let groupKey;
        if (this.sortField === 'date') {
          // 按日期分组
          groupKey = row.date;
        } else if (this.sortField === 'typeName') {
          // 按作业类型分组
          groupKey = row.homeworkTypeId;
        }
        
        // 生成唯一的分组标识
        const groupValues = this.homeworkRecords.map(r => 
          this.sortField === 'date' ? r.date : r.homeworkTypeId
        );
        const uniqueGroups = [...new Set(groupValues)];
        const groupIndex = uniqueGroups.indexOf(groupKey);
        
        // 使用不同的背景色类
        if (groupIndex % 2 === 0) {
          return 'group-row-light';
        } else {
          return 'group-row-dark';
        }
      }
      return '';
    },
    
    // 加载作业记录
    loadHomeworkRecords() {
      // 先清空作业记录数据，确保显示空状态
      this.homeworkRecords = [];
      // 使用新的聚合接口一次性获取所有需要的数据
      this.$http.get(`/homeworkAssignments/class/${this.classId}/details`)
        .then(response => {
          if (response.data.success) {
            // 直接赋值数据，让自定义排序功能处理排序
            this.homeworkRecords = response.data.data || [];

            // 默认排序为日期降序
            this.sortHomeworkRecords();
            // 初始化排序状态
            if (this.$refs.homeworkRecordsTable) {
              // 设置默认排序状态为日期降序
              this.$refs.homeworkRecordsTable.sort('date', 'descending');
              
              // 绑定自定义排序事件监听器
              this.$refs.homeworkRecordsTable.$on('sort-change', (sortInfo) => {
                if (sortInfo.prop === 'date') {
                  this.handleDateSort(sortInfo);
                } else if (sortInfo.prop === 'typeName') {
                  this.handleTypeSort(sortInfo);
                }
              });
            }
          } else {
            throw new Error(response.data.message || '获取作业记录失败');
          }
        })
        .catch(error => {
          console.error('加载作业记录失败:', error);
          // 加载失败时保持空状态
          this.homeworkRecords = [];
          this.$message.error('加载作业记录失败: ' + (error.response?.data?.message || error.message || '未知错误'));
        });
    },
    
    // 编辑作业内容
    editHomeworkContent(record) {
      this.editingHomeworkRecord = record;
      this.tempHomeworkContent = record.content || '';
      this.homeworkContentDialogVisible = true;
    },
    
    // 保存作业内容
    saveHomeworkContent(content) {
      // 如果传入了新的内容，则更新tempHomeworkContent
      if (content !== undefined) {
        this.tempHomeworkContent = content;
      }
      
      if (!this.editingHomeworkRecord) return;
      
      const contentData = {
        date: this.editingHomeworkRecord.date,
        homeworkTypeId: this.editingHomeworkRecord.homeworkTypeId,
        content: this.tempHomeworkContent,
        classId: this.classId
      };
      
      this.$http.post('/homeworkContents', contentData)
        .then(response => {
          this.$message.success('作业内容保存成功!');
          
          // 更新本地记录
          const index = this.homeworkRecords.findIndex(r => 
            r.date === this.editingHomeworkRecord.date && 
            r.homeworkTypeId === this.editingHomeworkRecord.homeworkTypeId
          );
          if (index > -1) {
            this.$set(this.homeworkRecords[index], 'content', this.tempHomeworkContent);
          }
          
          // 通过事件总线通知ControlPanel更新作业内容
          EventBus.$emit('homework-content-updated', {
            date: this.editingHomeworkRecord.date,
            typeId: this.editingHomeworkRecord.homeworkTypeId,
            content: this.tempHomeworkContent,
            classId: this.classId
          });
          
          this.closeHomeworkContentDialog();
        })
        .catch(error => {
          this.$message.error('作业内容保存失败: ' + (error.response?.data?.message || error.message || '未知错误'));
        });
    },
    
    // 关闭作业内容对话框
    closeHomeworkContentDialog() {
      this.homeworkContentDialogVisible = false;
      this.editingHomeworkRecord = null;
      this.tempHomeworkContent = '';
    },
    
    // 删除作业记录
    // 处理作业类型更新事件
    handleHomeworkTypesUpdated(payload) {
      // 检查是否是当前班级的作业类型更新
      if (payload.classId === this.classId) {
        console.log('ManagementDialog收到作业类型更新通知:', payload);
        
        // 刷新作业记录表
        this.refreshHomeworkRecords();
        
        // 如果当前在作业相关标签页，同时刷新作业类型树
        if (this.activeTab === 'homework') {
          this.loadHomeworkTypesForManagement();
        }
      }
    },
    
    // 刷新作业记录表
    refreshHomeworkRecords() {
      if (this.activeTab === 'homework' && this.classId) {
        this.loadHomeworkRecords();
      }
    },
    
    deleteHomeworkRecord(record) {
      this.$confirm(`确定要删除 ${record.date} 的 ${record.typeName} 作业记录吗？此操作将删除该作业的所有订正记录。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除作业记录
        this.$http.delete(`/homeworkAssignments/record?date=${record.date}&typeId=${record.homeworkTypeId}&classId=${this.classId}`)
          .then(response => {
            if (response.data.success) {
              this.$message.success('作业记录删除成功!');
              
              // 从本地列表中移除
              const index = this.homeworkRecords.findIndex(r => 
                r.date === record.date && r.homeworkTypeId === record.homeworkTypeId
              );
              if (index > -1) {
                this.homeworkRecords.splice(index, 1);
              }
              
              // 通过事件总线通知StudentGrid更新学生按钮订正状态
              EventBus.$emit('homework-record-deleted', {
                date: record.date,
                typeId: record.homeworkTypeId,
                classId: this.classId
              });
            } else {
              this.$message.error(response.data.message || '删除失败');
            }
          })
          .catch(error => {
            this.$message.error('删除失败: ' + (error.response?.data?.message || error.message || '未知错误'));
          });
      }).catch(() => {
        // 用户取消操作
      });
    }
  },
  mounted() {
    // 组件挂载时获取当前教师ID
    this.getCurrentTeacherId();
    
    // 监听作业类型更新事件
    EventBus.$on('homework-types-updated', this.handleHomeworkTypesUpdated);
  },
  beforeDestroy() {
    // 移除事件监听器
    EventBus.$off('homework-types-updated', this.handleHomeworkTypesUpdated);
  },
}
</script>

<style scoped>
/* 自定义样式，去掉margin-left并垂直居中 */
::v-deep .no-margin-left {
  display: flex !important;
  align-items: center !important;
}

::v-deep .no-margin-left .el-form-item__content {
  margin-left: 0 !important;
  flex: 1;
  display: flex;
  align-items: center;
}

/* 修改密码表单使用flex布局使左右对齐 */
.change-password-form {
  display: flex;
  flex-direction: column;
}

.change-password-form .el-form-item {
  display: flex;
  align-items: center;
}

.change-password-form .el-form-item__label {
  text-align: right;
  padding-right: 12px;
}

.change-password-form .el-form-item__content {
  flex: 1;
  margin-left: 0 !important;
}

/* 针对挂载到body的弹窗，使用::v-deep确保样式生效 */
::v-deep .management-dialog .el-form-item__content {
  margin-left: 0 !important;
}

/* 缩短下拉框宽度 */
 ::v-deep .short-select {
   width: 165px !important;
 }

/* 管理弹窗基础样式 */
.management-dialog .el-dialog__body {
  padding: 20px 40px !important;
  max-height: calc(80vh - 100px);
  overflow-y: auto;
}

.management-dialog .el-dialog__header {
  background: #40e0d0 !important;
}

/* 学生名单表格容器样式 - 解决滚动条遮挡圆角问题 */
.management-dialog .table-wrapper {
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  overflow: visible; /* 去掉滚动条 */
  position: relative;
}

/* 学生名单表格样式 */
.management-dialog .el-table {
  border: none; /* 移除表格自身的边框 */
  border-radius: 0; /* 移除表格自身的圆角 */
}

.management-dialog .el-table::before {
  /* 隐藏Element UI表格默认的底部边框 */
  display: none;
}

/* 表格头部样式 */
.management-dialog .el-table th {
  background-color: #f5f7fa;
  border-bottom: 1px solid #dcdfe6;
}

/* 表格数据行样式 */
.management-dialog .el-table td {
  border-bottom: 1px solid #dcdfe6;
}

/* 最后一行去掉底部边框 */
.management-dialog .el-table .el-table__body tr:last-child td {
  border-bottom: none;
}

/* 作业记录表格行背景色 */
.management-dialog .el-table .group-row-light {
  background-color: #ffffff;
}

/* 作业记录表斑马纹样式 - 使用更具体的选择器确保优先级 */
.management-dialog .el-table .group-row-light,
body .management-dialog .el-table .group-row-light {
  background-color: #f9f9f9 !important;
}

.management-dialog .el-table .group-row-dark,
body .management-dialog .el-table .group-row-dark {
  background-color: #f0f8ff !important;
}

/* 添加学生弹窗的全局样式 */
.management-add-students-dialog .aligned-textarea {
  resize: vertical;
}

.management-add-students-dialog .aligned-textarea .el-textarea__inner {
  line-height: 24px !important;
  padding: 5px !important;
}

/* 编辑学生弹窗样式 */
.student-edit-dialog ::v-deep .el-dialog__header {
  background: #6abfd1 !important;
}

/* 去掉编辑学生弹窗底部的背景色 */
.student-edit-dialog ::v-deep .el-dialog__footer {
  background-color: transparent !important;
}

/* 去掉添加学生弹窗底部的背景色 */
.management-add-students-dialog .el-dialog__footer {
  background-color: white !important;
}

/* 弹窗圆角一致性规范 */
.management-add-students-dialog .el-dialog {
  border-radius: 10px !important;
  overflow: hidden;
}

.management-add-students-dialog .el-dialog__header {
  background: #6abfd1 !important;
  border-radius: 10px 10px 0 0 !important;
}

/* 添加学生弹窗primary按钮样式 */
.management-add-students-dialog .el-button--primary:not(:disabled) {
  background: linear-gradient(90deg, #6abfd1, #6abfd1) !important;
  border: none !important;
  color: white !important;
}

.management-add-students-dialog .el-button--primary:not(:disabled):hover {
  background: linear-gradient(90deg, #5d8aa8, #4682b4) !important;
  border: none !important;
  color: white !important;
  transform: scale(1.05);
  transition: all 0.2s ease;
}

/* 学生编辑弹窗圆角 */
.management-dialog .el-dialog {
  border-radius: 10px !important;
  overflow: hidden;
}

.management-dialog .el-dialog__header {
  border-radius: 10px 10px 0 0 !important;
}

/* 防止学生编辑表单标签换行 - 简化版 */
.management-dialog .el-form-item {
  white-space: nowrap !important;
}

.management-dialog .el-form-item__label {
  white-space: nowrap !important;
  min-width: 80px !important;
}

/* 个人信息头部样式 */
.personal-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.personal-info-title h3 {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
}

.edit-actions {
  display: flex;
  gap: 10px;
}

/* 我的班级头部样式 */
.my-classes-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.my-classes-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
}

.my-classes-actions {
  display: flex;
  gap: 10px;
}

.my-classes-actions .disabled-class-btn {
  background-color: #c0c4cc !important;
  border-color: #c0c4cc !important;
  color: #ffffff !important;
  cursor: not-allowed !important;
}

/* 关于页面样式 */
.about-management {
  padding: 0 20px 20px;
}

.about-content {
  max-width: 900px;
  margin: 0 auto;
}

.project-intro, .feature-list, .tech-stack, .author-info {
  margin-bottom: 40px;
}

.project-intro h3, .feature-list h3, .tech-stack h3, .author-info h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 15px;
  border-bottom: 2px solid #6abfd1;
  padding-bottom: 10px;
}

.intro-text {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin: 0px;
  text-indent: 2em;
}

/* 功能特性样式 */
.features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

.feature-item:last-child {
  border-bottom: none;
}

.feature-item i {
  color: #67C23A;
  font-size: 16px;
  margin-right: 10px;
  margin-top: 3px;
  flex-shrink: 0;
}

.feature-item span {
  flex: 1;
}

/* 技术栈样式 */
.tech-items {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.tech-item {
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.tech-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.tech-icon {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  color: white;
  margin-right: 15px;
  flex-shrink: 0;
}

.tech-icon.backend {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.tech-icon.frontend {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.tech-icon.database {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.tech-icon.auth {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.tech-details {
  flex: 1;
}

.tech-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 0 0 5px 0;
}

.tech-desc {
  font-size: 13px;
  color: #999;
  margin: 0;
  line-height: 1.5;
}

/* 作者信息样式 */
.author-details {
  background-color: #f9f9f9;
  padding: 25px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.author-basic {
  margin-bottom: 25px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.author-name, .author-version, .author-update {
  font-size: 15px;
  color: #333;
  margin: 0 0 10px 0;
  line-height: 1.8;
}

.author-name strong, .author-version strong, .author-update strong {
  color: #6abfd1;
  font-weight: bold;
}

.wechat-qrcode {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.qrcode-container {
  flex: 1;
}

.wechat-label {
  font-size: 16px;
  color: #333;
  margin: 0 0 8px 0;
  font-weight: bold;
}

.wechat-tip {
  font-size: 13px;
  color: #999;
  margin: 0 0 15px 0;
}

.qrcode-image {
  width: 200px;
  height: 200px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 5px;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.qrcode-image:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>